import { buildJson } from "./payload.helper";

const labTestHelper = {
  forCreate: ({ name, status, permissions }) =>
    buildJson({
      name,
      status,
      permissions,
    }),

  forUpdate: (id, { name, status, permissions }) => ({
    id,
    body: buildJson({
      name,
      status,
      permissions,
    }),
  }),
};

export default labTestHelper;